export const OfferStatus = {
	ACCEPTED: "ACCEPTED",
	EXPIRED: "EXPIRED",
	NO_OFFER: "NO_OFFER",
	OPEN: "OPEN",
} as const

export type OfferStatus = (typeof OfferStatus)[keyof typeof OfferStatus]
